export const LS = {
  // auth related
  NEEDS_EMAIL_VERIFICATION: "needsEmailVerification",
  
  // vipps related
  USER: "user",
  AUTH_PROVIDER: "authProvider",
  AUTH_TYPE: "authType",
  CODE_VERIFIER: "code_verifier",
  NONCE: "nonce",
  STATE: "state",
  OPENID_CONF: "openidConfigVipps",
  VIPPS: "vipps",
  AWS: "aws",
  NETS: "nets",
  PHONE_VERIFICATION_SENT: "phoneVerificationSent",

  // storage related
  FACILITY_ID: "facilityId",
  COUNTRY: "country",
  LEVEL: "level",
  LANGUAGE: "lang",
  DISCOUNT_CODE: "discountCode",
  START_DATE: "startDate",
  EMAIL: "email",
  CHOSEN_LANG: "chosen_language",
  SUBSCRIPTION_TYPE: "subscriptionType",
  PAYMENT_SUCCESS: "paymentSuccess",
  DEFAULT_FACILITY_ID: "defaultFacilityId",
  DEFAULT_LEVEL: "defaultLevel",
  RESERVATION_ID: "reservationId",
  USERNAME:"username",
  
  CHECKOUT_SIZE: "checkout_size",
  CHECKOUT_CITY: "checkout_city",
  CHECKOUT_ADDRESS: "checkout_address",
  CHECKOUT_MOVE_IN_DATE: "checkout_move_in_date",
  CHECKOUT_TOTAL: "checkout_total",
  CHECKOUT_INSURANCE_PRICE: "checkout_insurance_price",
  TEMP_VERIFIED_WITH_SUMSUB: "temp_verified_with_sumsub",

  TEMP_DISCOUNT_CODE: "temp_discount_code",
  
  PENDING_RESERVATION_CHECKOUT: "pendingReservationCheckout",
  PRE_LOGIN_PARAMS: "preLoginParams",

  SELECTED_INSURANCES: "selectedInsurances",
  SELECTED_PRICES: "selectedPrices",
  SELECTED_OPTION_IDS: "selectedOptionIds",
  LAST_INSURANCE_OPTION_ID: "lastInsuranceOptionId",

  // bankid related
  BANKID_CODE_VERIFIER: "bankid_code_verifier",
  BANKID_NONCE: "bankid_nonce",
  BANKID_STATE: "bankid_state",
  BANKID_REDIRECT_TIME: "bankid_redirect_time",

  LOGIN_REDIRECT_ATTEMPTED: "loginRedirectAttempted",
};

